<template>
  <div v-if="value">
    <p v-if="value === '高'" :class="{ 'orange-bg': value === '高' }">
      <span>高</span>
    </p>
    <p v-if="value === '中'" :class="{ 'yellow-bg': value === '中' }">
      <span>中</span>
    </p>
    <p v-if="value === '低'" :class="{ 'gray-bg': value === '低' }">
      <span>低</span>
    </p>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      require: true,
      default: '',
    },
  },
};
</script>
